import { isRequired } from './isRequired';
import {
  always,
  compose,
  is,
  isNil,
  mergeLeft,
  replace,
  take,
  test,
  toString,
  unless,
  when
} from 'ramda';
import { Validator } from '@fasstech/oip-core/entities/helpers/validator';

export const zipCodeIsValid = (value, okFranceMetro, okDROM) =>
  Validator({
    type: [
      'postal',
      (value) =>
        (okFranceMetro ||
          !test(/^(?!97|98)[0-9]{5}$|^2[AB][0-9]{3}$/, value)) &&
        (okDROM ||
          !test(
            /^(971|972|973|974|975|976|977|978|984|986|987|988|989)[0-9]{2}$/,
            value
          ))
    ]
  }).validate(value)[0];

export const zipCodeRules = (
  required = true,
  okFranceMetro = true,
  okDROM = true
) =>
  when(always(required), mergeLeft(isRequired), {
    validate: (value) =>
      (!required && (isNil(value) || value === '')) ||
      zipCodeIsValid(value, okFranceMetro, okDROM) ||
      'Le format du code postal saisi est invalide'
  });

export const formatZipCode = (value) => {
  if (isNil(value)) {
    return value;
  }

  return compose(
    replace(/[^0-9]/g, ''),
    take(5),
    unless(is(String), toString)
  )(value);
};

export const INTERNATIONAL_ZIP_CODE_MAX_LENGTH = 10;

export const formatInternationalZipCode = (value) => {
  if (isNil(value)) {
    return value;
  }

  return compose(
    take(INTERNATIONAL_ZIP_CODE_MAX_LENGTH),
    replace(/[^0-9A-Za-z]/g, ''),
    unless(is(String), toString)
  )(value);
};

export const internationalZipCodeRules = (required = true) =>
  when(always(required), mergeLeft(isRequired), {
    validate: (value) =>
      (!isNil(value) && value.length
        ? value.length <= INTERNATIONAL_ZIP_CODE_MAX_LENGTH
        : !required) ||
      `Le code ZIP saisi doit comporter au maximum ${INTERNATIONAL_ZIP_CODE_MAX_LENGTH} caractères`
  });
